// When adding a new `*Sizes` variable, it's best to run through all possible
// options and track how many times each occurs. Then pick a sensible middle
// value and give that the name `md`.
// For all the ones that have a much lower count, go through the following list
// to determine which one to do. They are in descending order of desirability.
// Options:
// 1. See if you can change the height to an existing t-shirt size
// 2. Give them a t-shirt size
// 3. Ignore it and let it be a custom size

type FontSizes =
  | "x2s"
  | "x1s"
  | "sm"
  | "md"
  | "lg"
  | "x1l"
  | "x2l"
  | "x3l"
  | "x4l"
  | "x5l";

export const fontSizes: Record<FontSizes, `${number}rem`> = {
  x5l: "3.75rem",
  x4l: "3rem", // 48px
  x3l: "2.5rem", // 40px
  x2l: "2rem", // 32px
  x1l: "1.5rem", // 24px
  lg: "1.25rem", // 20px
  md: "1rem", // 16px
  sm: "0.875rem", // 14px
  x1s: "0.75rem", // 12px
  x2s: "0.5rem",
};

// TODO: Remove random rems? Or at least the ones that can be moved to the standard sizes?

// FULL LIST OF `rem`'S -- 2022-07-26
// "80rem"
// "71rem"
// "70rem"
// "60rem"
// "59.125rem"
// "59rem"
// "57rem"
// "55rem"
// "51.25rem"
// "50rem"
// "49.688rem"
// "48rem"
// "42rem"
// "41rem"
// "40.75rem"
// "40rem"
// "36.25rem"
// "35rem"
// "33.875rem"
// "32.875rem"
// "32.625rem"
// "31.25rem"
// "29rem"
// "27rem"
// "25rem"
// "24.375rem"
// "23.5rem"
// "23rem"
// "22.75rem"
// "22.5rem"
// "22rem"
// "20rem"
// "19.625rem"
// "18.75rem"
// "18rem"
// "17.5rem"
// "17rem"
// "16.875rem"
// "16rem"
// "15rem"
// "14rem"
// "13.75rem"
// "13.625rem"
// "12rem"
// "11.68rem"
// "11.25rem"
// "11rem"
// "10rem"
// "9.5rem"
// "9.125rem"
// "7.5rem"
// "7.125rem"
// "6.5rem"
// "6.25rem"
// "6rem"
// "5.625rem"
// "3.875rem"
// "3.5rem"
// "3.25rem"
// "2.125rem"
// "1.75rem"
// "1.3125rem"
// "1.2rem"
// "1.125rem"
// ".35rem"
// "0.25rem"
// "0.2rem"
// "0.125rem"
// "-1rem"
// "-0.5rem"
// "-8rem"
